/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import MuiExpansionPanel from '@mui/material/Accordion';
import MuiExpansionPanelDetails from '@mui/material/AccordionDetails';
import MuiExpansionPanelSummary from '@mui/material/AccordionSummary';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';

import { CIFonts } from 'shared';

import arrow from '../../../../assets/images/arrow_drop_down.svg';

export const Accordion = withStyles({
  root: {
    width: '100%',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiExpansionPanel);

export const AccordionSummary = withStyles({
  root: {
    padding: '0 16px 0 0',
    borderBottom: '1px solid #EEEEEE',
    '&$expanded': {
      minHeight: 52,
      borderColor: 'transparent',
    },
  },
  content: {
    margin: 0,
    '&$expanded': {
      margin: 0,
    },
  },
  expandIcon: {
    transform: 'rotate(90deg)',
  },
  expanded: {},
})(MuiExpansionPanelSummary);

export const AccordionDetails = withStyles(() => ({
  root: {
    padding: 0,
  },
}))(MuiExpansionPanelDetails);

export const createStatusTabStyles = makeStyles(() => ({
  root: {
    maxWidth: '100%',
  },
  logsContainer: {
    height: '450px',
    position: 'relative',
  },
  logs: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: 'auto',
    backgroundColor: '#0A1629',
    color: '#FFFFFF',
    fontSize: '14px',
    lineHeight: '21px',
    letterSpacing: '-0.71px',
    padding: '16px',
    borderRadius: '6px',
  },
  logsPre: {
    fontFamily: CIFonts.Code,
    margin: 0,
    padding: '5px 0',
  },
  header: {
    borderBottom: '2px solid #EEEEEE',
    paddingRight: '48px',
  },
  headerItem: {
    padding: '0 10px 10px',
    fontSize: '12px',
    lineHeight: '15px',
    textTransform: 'uppercase',
    borderWidth: '2px',
  },
  lastHeaderItems: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  actionsHeaderItem: {
    marginRight: '10px',
  },
  gridItem: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '9px 8px',
  },
  arrowIcon: {
    width: '24px',
    height: '24px',
    mask: `url('${arrow}')`,
    maskRepeat: 'no-repeat',
    backgroundColor: '#A2A7AE',
    transform: 'rotate(-90deg)',
  },
  chip: {
    cursor: 'pointer',
  },
  section: {
    width: '100%',
    padding: 0,
    margin: 0,
  },
  dlIconWrap: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  popover: {
    padding: '10px 15px',
  },
  restartBtn: {
    marginRight: '15px',
  },
}));
